import { createContext, type ReactNode, use } from 'react';
import type { PlaySession } from './play';

/**
 * How a page starts play sessions: mogzo.com for test communities (and published games,
 * M23), the admin site for a version's review data. Games only ever see the bridge.
 */
export interface PlayApi {
  /** The MOGZO API, which Game Services calls go to with the play token. */
  apiUrl: string;
  /** A play session for this game, from the player's own sign-in. */
  startSession(projectId: string): Promise<PlaySession>;
  /** Where the sign-in panel sends a guest, and back to `here` afterwards. */
  accountLinks?(here: string): { signIn: string; signUp: string };
}

const PlayApiContext = createContext<PlayApi | null>(null);

export function PlayApiProvider({ api, children }: { api: PlayApi; children: ReactNode }) {
  return <PlayApiContext value={api}>{children}</PlayApiContext>;
}

export function usePlayApi(): PlayApi {
  const api = use(PlayApiContext);
  if (!api) throw new Error('GameFrame needs a PlayApiProvider around it');
  return api;
}
